<template>
  <div class="">
    <Card class="">
      <template #title> Urun Listesi </template>
      <template #content>
        <div class="mt-1 mb-2 mr-3">
          <Button icon="pi pi-plus " size="small" label="Yeni" @click="_YeniUrun()" />
        </div>
        <DataTable v-if="DataTable_render" :columns="columns" :data="UrunListesi" :editbutton="true"
          v-on:set-child-data="getDataChild" />
      </template>
    </Card>
  </div>
</template>

<script>
import DataTable from "../../DataTable/BasicDataTable.vue";
import GlobalServis from "../../../../../services/GlobalServis";
import { required, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";


export default {
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      DataTable_render: true,
      UrunListesi: [],
      columns: [
        { field: "Ad", header: "Urun Adı" },
      ],
      UrunModal: false,
      UrunModelDurum: null,

      UrunAd: null,
      UrunAciklama: null,
      Urun_rowid: 0,
    };
  },
  methods: {
    getDataChild(getdata_child) {
      this.Urun_rowid = getdata_child.data.Urun_rowid;
      this.$router.push({ path: "/Urun/DuzenleUrun", query: { UrunNo: this.Urun_rowid } });
    },
    _YeniUrun() {
      this.$router.push({ path: "/Urun/YeniUrun" });
    },
    handleClick(isFormValid) {
      this.submitted = true;
      if (isFormValid) {
        let data = {
          Urun_rowid: this.Urun_rowid,
          UrunAd: this.UrunAd,
          UrunAciklama: this.UrunAciklama,
        };
        if (this.UrunModelDurum) {
          // Yeni Urun
          GlobalServis.GlobalServis("POST", "SetUrun", data).then((res) => {
            if (res.status == 200) {
              this.$toast.add({
                severity: "success",
                summary: "Başarılı",
                detail: "Urun oluşturulmuştur",
                life: 3000,
              });
              this.Refresh();
            } else if (res.response.status === 999) {
              this.$toast.add({
                severity: "warn",
                summary: "Uyarı",
                detail: res.response.data,
                life: 3000,
              });
            } else {
              this.$toast.add({
                severity: "error",
                summary: "Hata",
                detail: "Hata oldu",
                life: 3000,
              });
            }
          }).then(() => {
          });
        } else {
          // Edit Urun
          GlobalServis.GlobalServis("POST", "UpdateUrun", data).then((res) => {
            if (res.status == 200) {
              this.$toast.add({
                severity: "success",
                summary: "Başarılı",
                detail: "Ürün düzenlemiştir",
                life: 3000,
              });
              this.Refresh();
            } else if (res.response.status === 999) {
              this.$toast.add({
                severity: "warn",
                summary: "Uyarı",
                detail: res.response.data,
                life: 3000,
              });
            } else {
              this.$toast.add({
                severity: "error",
                summary: "Hata",
                detail: "Hata oldu",
                life: 3000,
              });
            }
          }).then(() => {
          });
        }
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "Gerekli Alan Uyarısı",
          detail: "Lütfen tüm alanları doldurunuz",
          life: 3000,
        });
      }
    },
    Refresh() {
      this.DataTable_render = false;
      this.$nextTick(() => {
        this.InitServis();
        this.DataTable_render = true;
      });
    },
    InitServis() {
      GlobalServis.GlobalServis("GET", "GetUrunTablosu", "").then((res) => {
        if (res.status == 200) {
          this.UrunListesi = res.data;
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
  },
  mounted() {
    this.InitServis();
  },
  components: {
    DataTable,
  },
  validations() {
    return {
      UrunAd: {
        required: helpers.withMessage("Bu alan boş bırakılamaz", required),
      },
      UrunAciklama: {
        required: helpers.withMessage("Bu alan boş bırakılamaz", required),
      },
    };
  },
};
</script>